import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	chart: {
		info: { logistics: 0, catalogue: 0, accountManager: 0, riskComp: 0, finance:0, admin: 0 },
		totalValue: { chart1: 0, chart2: 0 },
	},
	tableData: [{}],
};

export const UserSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		updateUserCharts: (state, action) => {
			state.chart = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { updateUserCharts } = UserSlice.actions;

export default UserSlice.reducer;
